<div class="SLV2-pyp-card-box" [ngStyle]="{'background': pypCardData.bgColor,'color':pypCardData.color}" (click)="navigateToPYTest()">
    <!-- <img [src]="pypCardData.url" class="SLV2-pyp-card-icon" /> -->
    <span> {{pypCardData.title}}</span>
</div>
